import React from "react";
import { FaTint, FaBug, FaSun, FaSnowflake } from "react-icons/fa";
import { GiBrickWall, GiEarthAmerica } from "react-icons/gi";

const Characteristics = () => {
  const items = [
    { title: "Moisture Resistant", icon: <FaTint size={50} /> },
    { title: "Termite Resistant", icon: <FaBug size={50} /> },
    { title: "Abrasion Resistant", icon: <GiBrickWall size={60} /> },
    { title: "UV Resistant", icon: <FaSun size={50} /> },
    { title: "Frost Resistant", icon: <FaSnowflake size={50} /> },
    { title: "Eco Friendly", icon: <GiEarthAmerica size={55} /> },
  ];

  const baseCardStyle = {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "16px",
    padding: "2.3rem 1.3rem",
    boxShadow: "0 10px 25px rgba(0,0,0,0.07)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "default",
  };

  const hoverStyle = {
    transform: "translateY(-6px)",
    boxShadow: "0 16px 32px rgba(0,0,0,0.12)",
  };

  return (
    <section style={{ padding: "4rem 0", textAlign: "center"}}>
      <div className="container">
        <div style={{ textTransform: "uppercase", fontSize: "0.78rem", letterSpacing: "0.18em", color: "#116530", fontWeight: 600, marginBottom: "0.3rem" }}>
          Our Characteristics
        </div>

        <h2 style={{ fontSize: "1.9rem", fontWeight: 800, marginBottom: "0.6rem", color: "#000" }}>
          Built for performance and sustainability
        </h2>

        <p style={{ fontSize: "1rem", color: "#4b5563", maxWidth: "32rem", margin: "0 auto 2rem" }}>
          EcoPro products are engineered to withstand extreme conditions while reducing environmental impact.
        </p>

        <div className="characteristics-grid">
          {items.map((item, index) => (
            <div
              key={index}
              style={baseCardStyle}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverStyle)}
              onMouseLeave={(e) => Object.assign(e.currentTarget.style, baseCardStyle)}
            >
              <div style={{ color: "#116530", marginBottom: "1rem" }}>{item.icon}</div>
              <div style={{ fontSize: "1.05rem", fontWeight: 700, color: "#116530", marginTop: "0.5rem" }}>
                {item.title}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Characteristics;
